import type { CentralRiskEventPayload } from '../components/central-monitoring/centralRiskEventTypes';
import { eventService } from '../services/eventService';
import {
  composeEventSnapshotWithBboxes,
  dataUrlToBase64,
} from './composeEventSnapshot';

/**
 * 감지 직후 증거(서버 HLS/스트림 수집 스케줄 + bbox 캡처)를 스테이징한다.
 * 알림 전송 시 이벤트에 attach, 닫기/오탐 시 discard.
 * 이미 저장된 WebSocket 이벤트에는 호출하지 않는다.
 *
 * 관제 MediaRecorder 클립은 UI 지연·오류를 유발해 사용하지 않음.
 */
export function scheduleRiskEvidenceAtDetection(
  payload: CentralRiskEventPayload
): void {
  if (payload.source === 'websocket') return;
  const cctvId = payload.cctvId;
  if (cctvId == null || !Number.isFinite(Number(cctvId))) return;
  const triggerTs = payload.triggerTs ?? Date.now() / 1000;

  void (async () => {
    let snapshotBase64: string | undefined;
    let snapshotRawBase64: string | undefined;
    const raw = payload.imageDataUrl?.trim();
    if (raw?.startsWith('data:')) {
      snapshotRawBase64 = dataUrlToBase64(raw);
      try {
        const composed = await composeEventSnapshotWithBboxes(raw, payload.bboxes);
        snapshotBase64 = dataUrlToBase64(composed);
      } catch {
        snapshotBase64 = snapshotRawBase64;
      }
    }

    await eventService.reportDrowningRisk({
      poolId: payload.poolId,
      cctvId: Number(cctvId),
      riskType: payload.riskType,
      triggerTs,
      testMode: payload.source === 'test',
      message: payload.message,
      location: payload.location,
      snapshotBase64,
      snapshotRawBase64,
      bboxes: payload.bboxes,
    });
  })().catch(() => {});
}
